module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("It’s All An Act")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#its-all-an-act"
    }
  }, [_vm._v("It’s All An Act")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#first-things-first"
    }
  }, [_vm._v("First Things First")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#before-you-begin"
    }
  }, [_vm._v("Before You Begin")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#what-to-wear"
    }
  }, [_vm._v("What to Wear")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#your-classroom"
    }
  }, [_vm._v("Your Classroom")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#arranging-the-desks"
    }
  }, [_vm._v("Arranging the Desks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#displays"
    }
  }, [_vm._v("Displays")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#equipment"
    }
  }, [_vm._v("Equipment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#first-lessons"
    }
  }, [_vm._v("First Lessons")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#so-what-to-do-first",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So, What to Do First?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#seating-plans",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seating Plans")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#assume-it-will-let-you-down",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assume IT Will Let You Down")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-power-place",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Power Place")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#stand-up",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stand Up")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#repeat-performance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repeat Performance")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#introductions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introductions")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#taking-the-register",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking the Register")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-pencil-sharpener-syndrome",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pencil Sharpener Syndrome")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#rambo-vs-clint-eastwood",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rambo vs Clint Eastwood")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#playing-the-game",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Playing the Game")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#making-tiny-things-big",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Tiny Things Big")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#routines",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Routines")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#homework-is-homework",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homework Is Homework")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#before-you-go",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before You Go")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#an-incremental-approach",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Incremental Approach")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#step-one-the-look",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step One The Look")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#step-two-the-name",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step Two The Name")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#step-three-the-name-version-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step Three The Name (Version Two)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#step-four-stand-up",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step Four Stand Up")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#step-five-stand-up-and-question",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step Five Stand Up and Question")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#stage-six-the-private-public-conversation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stage Six The Private-Public Conversation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#stage-seven-deferred-conversation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stage Seven Deferred Conversation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#stage-eight-scale-of-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stage Eight Scale of 1–10")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#stage-nine-theres-no-escape",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stage Nine There’s No Escape")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#stage-ten-use-your-army",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stage Ten Use Your Army")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#knotty-problems",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knotty Problems")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#the-cracked-record-technique",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cracked Record Technique")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#what-have-i-done-wrong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Have I Done Wrong?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#permission-to-speak-sir",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permission to Speak, Sir")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#location-location-location",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Location, Location, Location")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#techniques-to-try",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Techniques to Try")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#the-slow-walk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Slow Walk")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#counting-from-five-to-one",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Counting from Five to One")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#silent-counting-from-five-to-one",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silent Counting from Five to One")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#hands-up",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hands Up")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#keep-the-beat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keep the Beat")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#working-noise-level",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Working Noise Level")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#three-two-one",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three, Two, One")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#stop-stand-and-scan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stop, Stand and Scan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#breaking-the-spell",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking the Spell")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#in-the-dark",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Dark")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#lights-off",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lights Off")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#stop-please",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stop, Please")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#softly-spoken",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Softly Spoken")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#building-in-silence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building in Silence")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#interrupting-the-flow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interrupting the Flow")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#shutting-down-the-lesson",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shutting Down the Lesson")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#venting-your-spleen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Venting Your Spleen")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#selected-deafness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Deafness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#fly-on-the-wall",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fly on the Wall")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#reaping-and-sowing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reaping and Sowing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#the-vending-machine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vending Machine")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#crime-and-punishment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crime and Punishment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#detention-block",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Detention Block")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#whole-class-punishments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Class Punishments")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#hes-behind-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He’s Behind You!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#suspended-sentence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suspended Sentence")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch072#deal-or-no-deal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deal or No Deal?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch073#the-goldfish-bowl-syndrome",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Goldfish Bowl Syndrome")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch074#thats-my-job",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("That’s My Job")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch075#using-the-right-words",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using the Right Words")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch076#relationships",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relationships")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch077#dos-and-donts-be-positive",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do’s and Don’ts Be Positive")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch078#be-enthusiastic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Enthusiastic")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch079#be-kind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Kind")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch080#be-consistent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Consistent")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch081#be-polite",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Polite")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch082#be-rational",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Rational")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch083#be-fair",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Fair")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch084#be-honest-with-yourself",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Honest with Yourself")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch085#dont-be-sarcastic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t be Sarcastic")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch086#dont-deliberately-humiliate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Deliberately Humiliate")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch087#dont-touch-children",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Touch Children")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch088#backtracking",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Backtracking")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch089#things-that-make-behaviour-management-difficult",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Things That Make Behaviour Management Difficult")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch090#potentially-disruptive-activities",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potentially Disruptive Activities")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch091#reclaiming-the-ground",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reclaiming the Ground")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch092#beauty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beauty")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch093#the-beast",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beast")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch094#risky-strategies-open-discussions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Risky Strategies Open Discussions")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch095#you-have-the-power",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Have the Power")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#its-all-an-act"
    }
  }, [_vm._v("It’s All an Act")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0